import React, { Component } from "react";

import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import Dropdown from "../../components/Dropdown/Select";
import AutoSizeInput from "../../components/AutoSizeInput/AutoSizeInput";
import ImageUploader from "../ImageUploader/ImageUploader";

class ModalModify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      type: null,
      titulo: null,
      info: null,
      link: null,
      imageUrl: null,
      imageField: {
        image: ""
      }
    };
  }

  handleOnChange = evt => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  handleChangeTypeDropdown = label => {
    this.setState({ type: label });
  };

  handleUpdateButton = (imageToUpload, onHandleUploadImage) => {
    const newEvent = {
      id: this.props.eventToModify.id,
      type: this.state.type ? this.state.type : this.props.eventToModify.type,
      title: this.state.titulo
        ? this.state.titulo
        : this.props.eventToModify.titulo,
      info: this.state.info ? this.state.info : this.props.eventToModify.info,
      link: this.state.link ? this.state.link : this.props.eventToModify.link,
      imageurl: this.props.eventToModify.imageUrl
    };

    const formData = new FormData();
    formData.append("myImage", imageToUpload.image);

    if (imageToUpload.image !== "") {
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };

      onHandleUploadImage(formData, config, newEvent);
    } else {
      this.props.onClickUpdateButton(newEvent);
    }

    console.log(newEvent);
    //this.props.onClickUpdateButton(newEvent);
  };

  render() {
    const classes = {
      paper: {
        width: "50%",
        margin: "5% auto",
        backgroundColor: "white",
        border: "2px solid #dcdcdc",
        boxShadow: "5px",
        padding: "20px 20px"
      },
      buttonContainer: {
        textAlign: "center"
      },
      button: {
        margin: "0 auto"
      },
      buttonClose: {
        marginLeft: "480px"
      },
      formContainer: {
        display: "grid"
      },
      image: {
        margin: "0 auto",
        width: "400px",
        height: "auto",
        padding: "15px"
      },
      imageUploader: {
        margin: "0 auto",
        textAlign: "center"
      }
    };

    let commonForm =
      this.state.type !== "Visitas Guiadas" ? (
        <div style={classes.formContainer}>
          <Dropdown
            label={"Tipo"}
            initialType={this.props.eventToModify.type}
            types={this.props.types}
            onHandleChange={this.handleChangeTypeDropdown}
          />
          <AutoSizeInput
            onChange={this.handleOnChange}
            rows={1}
            label="Título"
            name="titulo"
            defaultValue={this.props.eventToModify.titulo}
          />
          <AutoSizeInput
            onChange={this.handleOnChange}
            name="info"
            rows={4}
            label="Texto informativo"
            defaultValue={this.props.eventToModify.info}
          />
          <AutoSizeInput
            onChange={this.handleOnChange}
            name="link"
            rows={1}
            label="Link de la información"
            defaultValue={this.props.eventToModify.link}
          />
          <ImageUploader
            defaultImage={this.props.eventToModify.imageUrl}
            fieldValues={this.props.fieldValues}
          />
          <Button
            style={classes.button}
            variant="contained"
            color="primary"
            onClick={() =>
              this.handleUpdateButton(
                this.props.fieldValues,
                this.props.onModifyImage
              )
            }
          >
            Actualizar Evento
          </Button>
        </div>
      ) : (
        <div style={classes.formContainer}>
          <Dropdown
            label={"Tipo"}
            initialType={this.props.eventToModify.type}
            types={this.props.types}
            onHandleChange={this.handleChangeTypeDropdown}
          />
          <AutoSizeInput
            onChange={this.handleOnChange}
            rows={1}
            label="Título"
            name="titulo"
            defaultValue={this.props.eventToModify.titulo}
          />
          <AutoSizeInput
            onChange={this.handleOnChange}
            name="info"
            rows={4}
            label="Días"
            defaultValue={this.props.eventToModify.info}
          />
          <AutoSizeInput
            onChange={this.handleOnChange}
            name="link"
            rows={1}
            label="Contacto"
            defaultValue={this.props.eventToModify.link}
          />
          <img
            src={this.props.eventToModify.imageUrl}
            alt={this.props.eventToModify.imageUrl}
            style={{ width: "400px", height: "auto" }}
          />
          <ImageUploader
            defaultImage={this.props.eventToModify.imageUrl}
            fieldValues={this.props.fieldValues}
          />
          <Button
            style={classes.button}
            variant="contained"
            color="primary"
            onClick={() =>
              this.handleUpdateButton(
                this.props.fieldValues,
                this.props.onModifyImage
              )
            }
          >
            Actualizar Evento
          </Button>
        </div>
      );
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.props.show}
          onClose={this.props.onClose}
        >
          <div style={classes.paper}>{commonForm}</div>
        </Modal>
      </div>
    );
  }
}

export default ModalModify;
